import { IntlKey } from 'locales';
import { FormattedMessage } from 'react-intl';

import { DropdownSectionTitleProps } from '../models';

export const DropdownSectionTitle = ({ title }: DropdownSectionTitleProps) => (
  <h6 className="dropdown-header">
    <FormattedMessage id={`appHeader.navigation.${title}` as IntlKey} />
  </h6>
);
